import { __decorate, __param } from 'tslib';
import { Optional, Inject, Self, Input, Output, Directive, NgModule } from '@angular/core';
import { tuiRequiredSetter } from '@taiga-ui/cdk/decorators';
import { TuiActiveZoneDirective } from '@taiga-ui/cdk/directives/active-zone';
import { TuiObscuredService, TuiParentsScrollService, TuiDestroyService } from '@taiga-ui/cdk/services';
import { Subject, EMPTY } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

/**
 * Directive that monitors element visibility
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@taiga-ui/cdk/directives/active-zone';
import * as ɵngcc2 from '@taiga-ui/cdk/services';
let TuiObscuredDirective = class TuiObscuredDirective {
    constructor(activeZone, obscured$) {
        this.enabled$ = new Subject();
        const mapped$ = obscured$.pipe(map(obscuredBy => !!obscuredBy &&
            (!activeZone ||
                !obscuredBy.length ||
                obscuredBy.every(element => !activeZone.contains(element)))));
        this.tuiObscured = this.enabled$.pipe(switchMap(enabled => (enabled ? mapped$ : EMPTY)));
    }
    set tuiObscuredEnabled(enabled) {
        this.enabled$.next(enabled);
    }
};
TuiObscuredDirective.ɵfac = function TuiObscuredDirective_Factory(t) { return new (t || TuiObscuredDirective)(ɵngcc0.ɵɵdirectiveInject(TuiActiveZoneDirective, 8), ɵngcc0.ɵɵdirectiveInject(TuiObscuredService, 2)); };
TuiObscuredDirective.ɵdir = ɵngcc0.ɵɵdefineDirective({ type: TuiObscuredDirective, selectors: [["", "tuiObscured", ""]], inputs: { tuiObscuredEnabled: "tuiObscuredEnabled" }, outputs: { tuiObscured: "tuiObscured" }, features: [ɵngcc0.ɵɵProvidersFeature([TuiObscuredService, TuiParentsScrollService, TuiDestroyService])] });
TuiObscuredDirective.ctorParameters = () => [
    { type: TuiActiveZoneDirective, decorators: [{ type: Optional }, { type: Inject, args: [TuiActiveZoneDirective,] }] },
    { type: TuiObscuredService, decorators: [{ type: Self }, { type: Inject, args: [TuiObscuredService,] }] }
];
__decorate([
    Input(),
    tuiRequiredSetter()
], TuiObscuredDirective.prototype, "tuiObscuredEnabled", null);
__decorate([
    Output()
], TuiObscuredDirective.prototype, "tuiObscured", void 0);
TuiObscuredDirective = __decorate([ __param(0, Optional()),
    __param(0, Inject(TuiActiveZoneDirective)),
    __param(1, Self()),
    __param(1, Inject(TuiObscuredService))
], TuiObscuredDirective);

let TuiObscuredModule = class TuiObscuredModule {
};
TuiObscuredModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: TuiObscuredModule });
TuiObscuredModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function TuiObscuredModule_Factory(t) { return new (t || TuiObscuredModule)(); } });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiObscuredDirective, [{
        type: Directive,
        args: [{
                selector: '[tuiObscured]',
                providers: [TuiObscuredService, TuiParentsScrollService, TuiDestroyService]
            }]
    }], function () { return [{ type: ɵngcc1.TuiActiveZoneDirective, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [TuiActiveZoneDirective]
            }] }, { type: ɵngcc2.TuiObscuredService, decorators: [{
                type: Self
            }, {
                type: Inject,
                args: [TuiObscuredService]
            }] }]; }, { tuiObscured: [{
            type: Output
        }], tuiObscuredEnabled: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(TuiObscuredModule, { declarations: [TuiObscuredDirective], exports: [TuiObscuredDirective] }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(TuiObscuredModule, [{
        type: NgModule,
        args: [{
                declarations: [TuiObscuredDirective],
                exports: [TuiObscuredDirective]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { TuiObscuredDirective, TuiObscuredModule };

//# sourceMappingURL=taiga-ui-cdk-directives-obscured.js.map